<div class="sidenav-content">
	<div class="card-title-block-non-sticky">
		<copo-back-button></copo-back-button>
		<span class="card-title-label" translate>menu.sales-services</span>
	</div>
	<div class="service-grid-container copo-container">

		<copo-check-offer-widget *ngIf="user.hasService('ND4ST')"
			headerLabel="arcelormittal.need4steel.entry"
			btnLabel="check.new.offer"
			btnRouterLink="/need4steel/offerlist">
		</copo-check-offer-widget>

		<copo-create-fastlane-widget *ngIf="user.hasService('PFAST')"
			headerLabel="fast.lane.entry"
			btnLabel="create.new.request"
			btnRouterLink="/fastlane/wizard">
		</copo-create-fastlane-widget>
		
		<copo-request-offer-widget *ngIf="user.hasService('EOFFR') && user.isOfferValidator()"
			headerLabel="eoffer.entry"
			btnLabel="eoffer.request.new.offer"
			btnRouterLink="/offer/wizard">
		</copo-request-offer-widget>

		<copo-create-order-widget *ngIf="user.hasService('EORDR')"
			headerLabel="order.entry"
			btnLabel="create.new.order"
			btnRouterLink="/order/wizard">
		</copo-create-order-widget>

		<copo-efeasibility-widget *ngIf="user.hasService('PFEAS')"
		headerLabel="dashboard.efeasibility"
		btnLabel="dashboard.efeasibility.add.new"
		btnRouterLink="/efeasibility/dashboard">
		</copo-efeasibility-widget>

	</div>
</div>